var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAllergies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3057 7.95406V2.28739C10.3057 1.84537 10.1294 1.42144 9.8155 1.10888C9.50164 0.796322 9.07596 0.620728 8.6321 0.620728C8.18824 0.620728 7.76255 0.796322 7.4487 1.10888C7.13484 1.42144 6.95852 1.84537 6.95852 2.28739V12.3929L5.12364 9.22794C5.01385 9.0382 4.86759 8.87186 4.69322 8.73844C4.51885 8.60502 4.31979 8.50713 4.10741 8.45037C3.89503 8.3936 3.6735 8.37907 3.45548 8.40761C3.23746 8.43615 3.02723 8.50719 2.83679 8.61669C2.64635 8.72618 2.47945 8.87198 2.34563 9.04574C2.2118 9.2195 2.11367 9.41782 2.05684 9.62937C2.00002 9.84092 1.98562 10.0615 2.01446 10.2786C2.04329 10.4957 2.11481 10.705 2.22492 10.8946C4.95022 16.6207 6.60851 18.6207 10.3057 18.6207C11.1848 18.6207 12.0553 18.4483 12.8675 18.1133C13.6797 17.7782 14.4177 17.2872 15.0393 16.6681C15.6609 16.049 16.154 15.3141 16.4904 14.5053C16.8268 13.6964 17 12.8295 17 11.9541V8.62073C17 8.1787 16.8237 7.75478 16.5098 7.44222C16.196 7.12966 15.7703 6.95406 15.3264 6.95406C14.8826 6.95406 14.4569 7.12966 14.143 7.44222C13.8292 7.75478 13.6528 8.1787 13.6528 8.62073",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 8.75V7.8125C13.125 7.3981 12.9604 7.00067 12.6674 6.70765C12.3743 6.41462 11.9769 6.25 11.5625 6.25C11.1481 6.25 10.7507 6.41462 10.4576 6.70765C10.1646 7.00067 10 7.3981 10 7.8125V8.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.1207,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 14.2207,
    r: 0.6,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 15.6207,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAllergies);
export default __webpack_public_path__ + "static/media/ic-allergies.1e4cc4472aba71bc26d432798bec22f6.svg";
export { ForwardRef as ReactComponent };